import React from "react";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import dioceseLogo from "assets/images/diocese-azul-row.png";
import {
  HeroWrapper,
  HeroInner,
  HeroContent,
  Eyebrow,
  Title,
  Subtitle,
  Actions,
  PrimaryButton,
  GhostButton,
  Stats,
  Stat,
  HeroMedia,
  VideoCard,
} from "./styles";

const VIDEO_URL =
  "https://studiumdocs.s3.us-east-1.amazonaws.com/33.261c41ajt-Apresenta%25C3%25A7%25C3%25A3o%2BDom%2BFrancisco%2B%2528baixa%2529.mp4";

const Hero = () => {
  const { push } = useHistory();

  const scrollToCourses = () => {
    const el = document.getElementById("cursos");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <HeroWrapper>
      <HeroInner>
        <HeroContent>
          <Eyebrow>
            <img src={dioceseLogo} alt="Arquidiocese de Joinville" />
            Centro de Formação · Arquidiocese de Joinville
          </Eyebrow>
          <Title>
            Aprenda sobre a sua fé, <span>onde e quando</span> você quiser.
          </Title>
          <Subtitle>
            Apresentamos a Studium, a ferramenta de formação online da
            Arquidiocese de Joinville. Cursos práticos sobre a Igreja Católica,
            Teologia,
            Bíblia, Pastorais e Movimentos — com certificado de conclusão.
          </Subtitle>
          <Actions>
            <PrimaryButton onClick={() => push("register")}>
              Cadastrar
            </PrimaryButton>
            <GhostButton onClick={scrollToCourses}>Ver cursos</GhostButton>
          </Actions>
          <Stats>
            <Stat>
              <strong>100%</strong>
              <span>Online e no seu ritmo</span>
            </Stat>
            <Stat>
              <strong>Certificado</strong>
              <span>Ao concluir o curso</span>
            </Stat>
            <Stat>
              <strong>App + Site</strong>
              <span>Acesse de qualquer lugar</span>
            </Stat>
          </Stats>
        </HeroContent>
        <HeroMedia>
          <VideoCard>
            <div className="player-wrapper">
              <ReactPlayer
                className="react-player"
                url={VIDEO_URL}
                controls
                width="100%"
                height="100%"
                onContextMenu={(e) => e.preventDefault()}
                config={{
                  file: {
                    attributes: {
                      controlsList: "nodownload",
                      disablePictureInPicture: true,
                    },
                  },
                }}
              />
            </div>
          </VideoCard>
        </HeroMedia>
      </HeroInner>
    </HeroWrapper>
  );
};

export default Hero;
